import appCorporateTransportationSubmission from "../../views/appSettings/corporateTransportationSubmission.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("corporatetransportationsubmission", {
    url: "corporatetransportationsubmission/:id",
    parent: "app",
    views: {
      view: {
        template: appCorporateTransportationSubmission,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateTransportationSubmission" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmission/corporateTransportationSubmission.urls.js